// Predictive Search Function
async function setPredictiveSearch(term, resultContainer) {
  
  try {
    const url = window.routes.predictive_search_url + "?q=" + term + "&section_id=predictive-search";
    const response = await fetch(url);
    if (!response.ok) throw new Error(`Response status: ${response.status}`);

    const data = await response.text();
    const doc = new DOMParser().parseFromString(data, "text/html");

    const resultHTML = doc.getElementById("predictive-search-results").innerHTML;
    resultContainer.innerHTML = resultHTML;

    return true;
  } catch (error) {
    console.error(error.message);
  }
}

// Multiple Search Inputs
document.querySelectorAll(".search__input").forEach((input) => {
  let timer;
  const resultContainer = input.closest("form").querySelector(".mini-search");

  input.addEventListener("input", function (event) {
    resultContainer.innerHTML = "";
    const value = event.target.value.trim();

    if (value.length > 0) {
      resultContainer.style.display = "flex";
      resultContainer.innerHTML = `<div class="spin-wrapper"><div class="spinner"></div></div>`;
      clearTimeout(timer);
      timer = setTimeout(() => {
        setPredictiveSearch(value, resultContainer);
      }, 700);
    } else {
      resultContainer.style.display = "none";
    }
  });

  // Hide popup when clicking outside
  document.addEventListener("click", function (event) {
    if (!resultContainer.contains(event.target) && !input.contains(event.target)) {
      resultContainer.style.display = "none";
    }
  });
});
